const BillingPaymentSessionInfo = ({
    referenceKey = '',
    secret = '',
    brand = '',
    businessUnit = '',
    userId = '',
    metroidConfigUrl = '',
} = {}) => ({
    referenceKey: String(referenceKey),
    secret: String(secret),
    brand: String(brand),
    businessUnit: String(businessUnit),
    userId: String(userId),
    metroidConfigUrl: String(metroidConfigUrl),
});

export default BillingPaymentSessionInfo;
